import { render } from "./AddPrixProduitCondTypeClientPage.vue?vue&type=template&id=34a96edf&ts=true"
import script from "./AddPrixProduitCondTypeClientPage.vue?vue&type=script&lang=ts"
export * from "./AddPrixProduitCondTypeClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__